(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  var container = document.querySelector('.slideshow-container-bro');
  var carousel = document.querySelector('.slideshow-carousel-bro');
  var slides = document.querySelectorAll('.slideshow-slide-bro');
  var paginationContainer = document.querySelector('.slideshow-pagination-bro');

  if (!container || !carousel || slides.length === 0) return;

  var totalSlides = slides.length;
  var currentIndex = 0;
  var autoSlide;

  /* =========================
     GET ACTIVE IMAGE
  ========================== */

  function getActiveImage(slide) {

    if (!slide) return null;

    var images = slide.querySelectorAll('img');

    for (var i = 0; i < images.length; i++) {

      var style = window.getComputedStyle(images[i]);

      if (
        style.display !== 'none' &&
        images[i].offsetWidth > 0
      ) {
        return images[i];
      }

    }

    return null;
  }


  /* =========================
     AUTO HEIGHT
  ========================== */

  function updateCarouselHeight() {

    var activeSlide = slides[currentIndex];

    if (!activeSlide) return;

    var activeImage = getActiveImage(activeSlide);

    if (!activeImage) return;

    function setHeight() {

      var height = activeImage.getBoundingClientRect().height;

      if (height > 0) {
        carousel.style.height = height + 'px';
      }

    }

    /* Image already loaded */
    if (activeImage.complete) {
      setHeight();
    } else {
      activeImage.addEventListener('load', setHeight, {
        once: true
      });
    }

    /* Extra resize check */
    requestAnimationFrame(setHeight);
  }


  /* =========================
     CREATE PAGINATION DOTS
  ========================== */

  slides.forEach(function (_, index) {

    var dot = document.createElement('div');

    dot.classList.add('slideshow-dot-bro');

    if (index === 0) {
      dot.classList.add('active');
    }

    dot.addEventListener('click', function () {

      clearInterval(autoSlide);

      goToSlide(index);

      restartAutoSlide();

    });

    paginationContainer.appendChild(dot);

  });

  var dots = document.querySelectorAll('.slideshow-dot-bro');


  /* =========================
     GO TO SLIDE
  ========================== */

  function goToSlide(index) {

    currentIndex =
      (index + totalSlides) % totalSlides;

    var offset = -currentIndex * 100;

    carousel.style.transform =
      'translate3d(' + offset + '%, 0, 0)';

    updateDots();

    updateCarouselHeight();
  }


  /* =========================
     UPDATE DOTS
  ========================== */

  function updateDots() {

    dots.forEach(function (dot, idx) {

      dot.classList.toggle(
        'active',
        idx === currentIndex
      );

    });

  }


  /* =========================
     NEXT / PREVIOUS
  ========================== */

  function showNextSlide() {
    goToSlide(currentIndex + 1);
  }

  function showPrevSlide() {
    goToSlide(currentIndex - 1);
  }


  /* =========================
     AUTOPLAY
  ========================== */

  function startAutoSlide() {

    autoSlide = setInterval(function () {

      showNextSlide();

    }, 5000);

  }

  function restartAutoSlide() {

    clearInterval(autoSlide);

    startAutoSlide();

  }


  /* =========================
     ARROWS
  ========================== */

  var nextButton =
    container.querySelector('.arrow-next');

  var prevButton =
    container.querySelector('.arrow-prev');


  if (nextButton) {

    nextButton.addEventListener('click', function () {

      showNextSlide();

      restartAutoSlide();

    });

  }


  if (prevButton) {

    prevButton.addEventListener('click', function () {

      showPrevSlide();

      restartAutoSlide();

    });

  }


  /* =========================
     TOUCH SWIPE
  ========================== */

  var touchStartX = 0;
  var touchStartY = 0;
  var touchEndX = 0;
  var touchEndY = 0;

  var isSwiping = false;


  container.addEventListener(
    'touchstart',
    function (e) {

      if (!e.touches || !e.touches.length) return;

      touchStartX =
        e.touches[0].clientX;

      touchStartY =
        e.touches[0].clientY;

      touchEndX = touchStartX;
      touchEndY = touchStartY;

      isSwiping = true;

      clearInterval(autoSlide);

    },
    { passive: true }
  );


  container.addEventListener(
    'touchmove',
    function (e) {

      if (!isSwiping || !e.touches.length) return;

      touchEndX =
        e.touches[0].clientX;

      touchEndY =
        e.touches[0].clientY;

    },
    { passive: true }
  );


  container.addEventListener(
    'touchend',
    function () {

      if (!isSwiping) return;

      isSwiping = false;

      var swipeDistanceX =
        touchEndX - touchStartX;

      var swipeDistanceY =
        touchEndY - touchStartY;

      var minSwipeDistance = 50;


      if (
        Math.abs(swipeDistanceX) > minSwipeDistance &&
        Math.abs(swipeDistanceX) >
        Math.abs(swipeDistanceY)
      ) {

        if (swipeDistanceX < 0) {

          showNextSlide();

        } else {

          showPrevSlide();

        }

      }

      restartAutoSlide();

    },
    { passive: true }
  );


  /* =========================
     IMAGE LOAD HANDLING
  ========================== */

  slides.forEach(function (slide) {

    var images = slide.querySelectorAll('img');

    images.forEach(function (image) {

      image.addEventListener('load', function () {

        updateCarouselHeight();

      });

    });

  });


  /* =========================
     WINDOW RESIZE
  ========================== */

  window.addEventListener('resize', function () {

    updateCarouselHeight();

  });


  /* =========================
     INITIALIZE
  ========================== */

  updateCarouselHeight();

  startAutoSlide();

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
